// HomePage.js
import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Button from "@mui/material/Button";
import Toolbar from "@mui/material/Toolbar";

// Reducer objects
import { CHANGE_SITE_INFO } from "../constants/actionTypes";

const Root = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  [theme.breakpoints.down('sm')]: {
    justifyContent: "flex-start",
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: 0,
  [theme.breakpoints.down('sm')]: {
    marginTop: "16px",
    justifyContent: "space-between",
    width: "100%",
  },
}));

const crumbsStartSx = { color: "rgba(0, 0, 0, 0.54)" };
const buttonSx = { marginLeft: "16px" };

function LayoutHeader({ dispatchSI, authState, pageName}) {
  const goToDonate = () => {
    var newWindow = window.open();
    newWindow.opener = null;
    newWindow.location = "https://donorbox.org/support-armalytics";
  };

  const handleItemSelect = () => {
    dispatchSI({type: CHANGE_SITE_INFO, payload: {open: true, page: "whySignUp"}});
  }

  return (
    <Root id="back-to-top-anchor">
      <Breadcrumbs aria-label="breadcrumb">
        <Typography sx={crumbsStartSx} color="textPrimary" component="h1">Home</Typography>
        <Typography color="textPrimary" component="h1">{ pageName }</Typography>
      </Breadcrumbs>

      <StyledToolbar disableGutters={true} >
        <Button
          size="small"
          sx={buttonSx}
          variant="outlined"
          color="primary"
          onClick={goToDonate}
        >
          Donate
        </Button>
      </StyledToolbar>
    </Root>
  );
}

LayoutHeader.propTypes = {
    dispatchSI: PropTypes.func,
    authState: PropTypes.string,
    pageName: PropTypes.string,
};

export default LayoutHeader;
